import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemStateAction extends Cloneable {
    static NONE = new ItemStateAction(0, "NONE");

    static _values = [
        ItemStateAction.NONE,
        new ItemStateAction(1, "REMOVE"),
        new ItemStateAction(8, "COLLECT"),
        new ItemStateAction(2, "UPGRADE"),
        new ItemStateAction(4, "DOWNGRADE"),
        new ItemStateAction(10, "EXPLOSION"),
        new ItemStateAction(11, "EXPLOSION_HARD"),


        new ItemStateAction(3, "RESET"),
        new ItemStateAction(5, "RESET_TO_BUILD"),
        new ItemStateAction(6, "RESET_TO_MINE"),
        new ItemStateAction(7, "RESET_TO_HARVEST"),
        new ItemStateAction(9, "RESET_TO_REMOVE")
    ];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemStateAction.getValue(id));
        });
    }

    static getValues() {
        return ItemStateAction._values;
    }

    static getValue(id) {
        let value = ItemStateAction._values.find(v => v.id === id) || null;
        console.assert(value, "unknown action id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemStateAction) {
            return ItemStateAction._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return ItemStateAction.NONE.equal(value);
    }

    constructor(id = 0, name = "None") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemStateAction) {
            return this.id === value.id;
        } else if (Number.isInteger(value)) {
            return this.id === value;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemStateAction());
        } else if (target instanceof ItemStateAction) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemStateAction, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});